// nav routes
export const OVERVIEW = "overview";
export const REQUIREMENTS = "requirements";
export const COMPENSATION = "compensation";
export const SPECIFICS = "specifics";
export const AGENCIES = "agencies";
export const REVIEW = "review";

export const SECTIONS = [
  OVERVIEW,
  REQUIREMENTS,
  COMPENSATION,
  SPECIFICS,
  AGENCIES,
  REVIEW,
];

export const WORKDAY_SECTIONS = [
  OVERVIEW,
  COMPENSATION,
  AGENCIES,
  REVIEW,
];

// remote work options
export const NON_REMOTE = "Yes, they must report in-person to a specific location";
export const REMOTE_BUT = "No, but they must be able to service a general area";
export const REMOTE = "No, they can work from anywhere";

export const REMOTE_WORK_OPTIONS = [NON_REMOTE, REMOTE_BUT, REMOTE];

// save statuses
export const SAVED = "saved";
export const UNSAVED = "unsaved";
export const SAVING = "saving";

const OVERVIEW_FIELDS = [
  "organization_profile_id",
  "title",
  "level",
  "reports_to",
  "vacant_since",
  "position_count",
  "locations",
  "travel_required",
  "work_remotely",
  "roles",
  "visa_support",
  "visa_support_non_us",
  "evergreen",
];

const REQUIREMENTS_FIELDS = ["description", "must_haves", "nice_to_haves"];

const COMPENSATION_FIELDS = [
  "currency",
  "salary_min",
  "salary_max",
  "signing_bonus_type",
  "bonus_description",
  "relocation_package",
  "culture_and_perks",
  "corporate_culture_url",
  "benefits",
];

const SPECIFICS_FIELDS = [
  "ats_application_url",
  "document",
  "institutions_to_source_from",
  "institutions_to_avoid",
  "interview_steps",
  "invoice_memo",
  "ofccp",
  "screening_questions",
  "deferred_invoice_memo",
  "deferred_invoice_memo_email",
  "job_id",
  "individual_id",
  "position_managers",
];

const AGENCY_FIELDS = [
  "community_inclusion",
  "selected_agencies",
  "userAddedAgencies",
  "userRemovedAgencies",
  "suggested_agencies",
  "agencySelectionType",
  "selected_agency_list",
  "standardized_preferred_fee_option_id",
];

export const WORKDAY_SECTION_FIELDS = {
  [OVERVIEW]: OVERVIEW_FIELDS.concat(["job_description"]),
  [COMPENSATION]: COMPENSATION_FIELDS,
  [AGENCIES]: AGENCY_FIELDS,
};

export const SECTION_FIELDS = {
  [OVERVIEW]: OVERVIEW_FIELDS,
  [REQUIREMENTS]: REQUIREMENTS_FIELDS,
  [COMPENSATION]: COMPENSATION_FIELDS,
  [SPECIFICS]: SPECIFICS_FIELDS,
  [AGENCIES]: AGENCY_FIELDS,
};

export const ALL_FIELDS = [
  OVERVIEW,
  REQUIREMENTS,
  COMPENSATION,
  SPECIFICS,
  AGENCIES,
].reduce((fieldList, section) => fieldList.concat(SECTION_FIELDS[section]), []);
